// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v7.35.1
// source: events.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Struct, Value } from "./google/protobuf/struct";
import { JsonPatchOperation } from "./patch";
import { Interrupt, Message } from "./types";

export const protobufPackage = "ag_ui";

export enum EventType {
  TEXT_MESSAGE_START = 0,
  TEXT_MESSAGE_CONTENT = 1,
  TEXT_MESSAGE_END = 2,
  TOOL_CALL_START = 3,
  TOOL_CALL_ARGS = 4,
  TOOL_CALL_END = 5,
  STATE_SNAPSHOT = 6,
  STATE_DELTA = 7,
  MESSAGES_SNAPSHOT = 8,
  RAW = 9,
  CUSTOM = 10,
  RUN_STARTED = 11,
  RUN_FINISHED = 12,
  RUN_ERROR = 13,
  STEP_STARTED = 14,
  STEP_FINISHED = 15,
  SUBAGENT_STARTED = 16,
  SUBAGENT_FINISHED = 17,
  SUBAGENT_ERROR = 18,
  UNRECOGNIZED = -1,
}

export interface BaseEvent {
  type: EventType;
  timestamp?: number | undefined;
  rawEvent?:
    | any
    | undefined;
  /**
   * Extra information, open by key. Declared here so every event carries it.
   *
   * Struct is map<string, Value>, and Value has NullValue, so a null *value*
   * under a key survives the binary transport. Message-field presence keeps an
   * absent object distinguishable from an empty one.
   */
  metadata: { [key: string]: any } | undefined;
}

export interface TextMessageStartEvent {
  baseEvent: BaseEvent | undefined;
  messageId: string;
  role?: string | undefined;
  name?: string | undefined;
  subagentRunId?: string | undefined;
}

export interface TextMessageContentEvent {
  baseEvent: BaseEvent | undefined;
  messageId: string;
  delta: string;
  subagentRunId?: string | undefined;
}

export interface TextMessageEndEvent {
  baseEvent: BaseEvent | undefined;
  messageId: string;
  subagentRunId?: string | undefined;
}

export interface ToolCallStartEvent {
  baseEvent: BaseEvent | undefined;
  toolCallId: string;
  toolCallName: string;
  parentMessageId?: string | undefined;
  subagentRunId?: string | undefined;
}

export interface ToolCallArgsEvent {
  baseEvent: BaseEvent | undefined;
  toolCallId: string;
  delta: string;
  subagentRunId?: string | undefined;
}

export interface ToolCallEndEvent {
  baseEvent: BaseEvent | undefined;
  toolCallId: string;
  subagentRunId?: string | undefined;
}

/**
 * StateSnapshotEvent / StateDeltaEvent carry subagent_run_id because they are
 * attributable: the protocol design lists them alongside the other standalone
 * events. Attribution here is PROVENANCE, not ownership -- it records which
 * subagent produced the update, while the state stays run-scoped and is applied
 * run-scoped. There is no per-subagent state.
 */
export interface StateSnapshotEvent {
  baseEvent: BaseEvent | undefined;
  snapshot: any | undefined;
  subagentRunId?: string | undefined;
}

export interface StateDeltaEvent {
  baseEvent: BaseEvent | undefined;
  delta: JsonPatchOperation[];
  subagentRunId?: string | undefined;
}

export interface MessagesSnapshotEvent {
  baseEvent: BaseEvent | undefined;
  messages: Message[];
}

export interface RawEvent {
  baseEvent: BaseEvent | undefined;
  event: any | undefined;
  source?: string | undefined;
  subagentRunId?: string | undefined;
}

export interface CustomEvent {
  baseEvent: BaseEvent | undefined;
  name: string;
  value?: any | undefined;
  subagentRunId?: string | undefined;
}

export interface RunStartedEvent {
  baseEvent: BaseEvent | undefined;
  threadId: string;
  runId: string;
}

/**
 * Numeric-only, per-(provider, model) token usage summary. Carries no
 * content-bearing or identifying fields — only labels and token counts.
 */
export interface Usage {
  provider?: string | undefined;
  model?: string | undefined;
  inputTokens?: number | undefined;
  outputTokens?: number | undefined;
  totalTokens?: number | undefined;
  reasoningTokens?: number | undefined;
  cachedInputTokens?: number | undefined;
}

export interface RunFinishedEvent {
  baseEvent: BaseEvent | undefined;
  threadId: string;
  runId: string;
  result?: any | undefined;
  outcome: string;
  interrupts: Interrupt[];
  usage: Usage[];
}

export interface RunErrorEvent {
  baseEvent: BaseEvent | undefined;
  code?: string | undefined;
  message: string;
  usage: Usage[];
}

export interface StepStartedEvent {
  baseEvent: BaseEvent | undefined;
  stepName: string;
  subagentRunId?: string | undefined;
}

export interface StepFinishedEvent {
  baseEvent: BaseEvent | undefined;
  stepName: string;
  subagentRunId?: string | undefined;
}

export interface TextMessageChunkEvent {
  baseEvent: BaseEvent | undefined;
  messageId?: string | undefined;
  role?: string | undefined;
  delta?: string | undefined;
  name?: string | undefined;
  subagentRunId?: string | undefined;
}

export interface ToolCallChunkEvent {
  baseEvent: BaseEvent | undefined;
  toolCallId?: string | undefined;
  toolCallName?: string | undefined;
  parentMessageId?: string | undefined;
  delta?: string | undefined;
  subagentRunId?: string | undefined;
}

/**
 * Subagent lifecycle. Field sets mirror the protocol schemas in
 * @ag-ui/core (SubagentStartedEventSchema and friends).
 */
export interface SubagentStartedEvent {
  baseEvent: BaseEvent | undefined;
  subagentRunId: string;
  name: string;
  description?: string | undefined;
  parentSubagentRunId?:
    | string
    | undefined;
  /**
   * Correlates the subagent with the tool call that spawned it, for the
   * agents-as-tools pattern, without a consumer having to read raw_event.
   */
  parentToolCallId?: string | undefined;
  parentMessageId?: string | undefined;
}

export interface SubagentFinishedEvent {
  baseEvent: BaseEvent | undefined;
  subagentRunId: string;
  /** The subagent's completion payload, mirroring RunFinishedEvent.result. */
  result?:
    | any
    | undefined;
  /**
   * Typed outcome, flattened like RunFinishedEvent's: "" (legacy success,
   * field omitted on the JSON side), "success", or "suspended".
   */
  outcome: string;
  /**
   * Ids of the run-level interrupts this subagent directly owns; only
   * meaningful when outcome == "suspended". May be empty for an ancestor
   * suspended because a descendant interrupted.
   */
  interruptIds: string[];
}

export interface SubagentErrorEvent {
  baseEvent: BaseEvent | undefined;
  subagentRunId: string;
  message: string;
  code?: string | undefined;
}

export interface Event {
  textMessageStart?: TextMessageStartEvent | undefined;
  textMessageContent?: TextMessageContentEvent | undefined;
  textMessageEnd?: TextMessageEndEvent | undefined;
  toolCallStart?: ToolCallStartEvent | undefined;
  toolCallArgs?: ToolCallArgsEvent | undefined;
  toolCallEnd?: ToolCallEndEvent | undefined;
  stateSnapshot?: StateSnapshotEvent | undefined;
  stateDelta?: StateDeltaEvent | undefined;
  messagesSnapshot?: MessagesSnapshotEvent | undefined;
  raw?: RawEvent | undefined;
  custom?: CustomEvent | undefined;
  runStarted?: RunStartedEvent | undefined;
  runFinished?: RunFinishedEvent | undefined;
  runError?: RunErrorEvent | undefined;
  stepStarted?: StepStartedEvent | undefined;
  stepFinished?: StepFinishedEvent | undefined;
  textMessageChunk?: TextMessageChunkEvent | undefined;
  toolCallChunk?: ToolCallChunkEvent | undefined;
  subagentStarted?: SubagentStartedEvent | undefined;
  subagentFinished?: SubagentFinishedEvent | undefined;
  subagentError?: SubagentErrorEvent | undefined;
}

function createBaseBaseEvent(): BaseEvent {
  return { type: 0, timestamp: undefined, rawEvent: undefined, metadata: undefined };
}

export const BaseEvent: MessageFns<BaseEvent> = {
  encode(message: BaseEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.timestamp !== undefined) {
      writer.uint32(16).int64(message.timestamp);
    }
    if (message.rawEvent !== undefined) {
      Value.encode(Value.wrap(message.rawEvent), writer.uint32(26).fork()).join();
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BaseEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBaseEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rawEvent = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BaseEvent>, I>>(base?: I): BaseEvent {
    return BaseEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BaseEvent>, I>>(object: I): BaseEvent {
    const message = createBaseBaseEvent();
    message.type = object.type ?? 0;
    message.timestamp = object.timestamp ?? undefined;
    message.rawEvent = object.rawEvent ?? undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseTextMessageStartEvent(): TextMessageStartEvent {
  return { baseEvent: undefined, messageId: "", role: undefined, name: undefined, subagentRunId: undefined };
}

export const TextMessageStartEvent: MessageFns<TextMessageStartEvent> = {
  encode(message: TextMessageStartEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.messageId !== "") {
      writer.uint32(18).string(message.messageId);
    }
    if (message.role !== undefined) {
      writer.uint32(26).string(message.role);
    }
    if (message.name !== undefined) {
      writer.uint32(34).string(message.name);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(42).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextMessageStartEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextMessageStartEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TextMessageStartEvent>, I>>(base?: I): TextMessageStartEvent {
    return TextMessageStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextMessageStartEvent>, I>>(object: I): TextMessageStartEvent {
    const message = createBaseTextMessageStartEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.messageId = object.messageId ?? "";
    message.role = object.role ?? undefined;
    message.name = object.name ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseTextMessageContentEvent(): TextMessageContentEvent {
  return { baseEvent: undefined, messageId: "", delta: "", subagentRunId: undefined };
}

export const TextMessageContentEvent: MessageFns<TextMessageContentEvent> = {
  encode(message: TextMessageContentEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.messageId !== "") {
      writer.uint32(18).string(message.messageId);
    }
    if (message.delta !== "") {
      writer.uint32(26).string(message.delta);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(34).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextMessageContentEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextMessageContentEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.delta = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TextMessageContentEvent>, I>>(base?: I): TextMessageContentEvent {
    return TextMessageContentEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextMessageContentEvent>, I>>(object: I): TextMessageContentEvent {
    const message = createBaseTextMessageContentEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.messageId = object.messageId ?? "";
    message.delta = object.delta ?? "";
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseTextMessageEndEvent(): TextMessageEndEvent {
  return { baseEvent: undefined, messageId: "", subagentRunId: undefined };
}

export const TextMessageEndEvent: MessageFns<TextMessageEndEvent> = {
  encode(message: TextMessageEndEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.messageId !== "") {
      writer.uint32(18).string(message.messageId);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(26).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextMessageEndEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextMessageEndEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TextMessageEndEvent>, I>>(base?: I): TextMessageEndEvent {
    return TextMessageEndEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextMessageEndEvent>, I>>(object: I): TextMessageEndEvent {
    const message = createBaseTextMessageEndEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.messageId = object.messageId ?? "";
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseToolCallStartEvent(): ToolCallStartEvent {
  return {
    baseEvent: undefined,
    toolCallId: "",
    toolCallName: "",
    parentMessageId: undefined,
    subagentRunId: undefined,
  };
}

export const ToolCallStartEvent: MessageFns<ToolCallStartEvent> = {
  encode(message: ToolCallStartEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.toolCallId !== "") {
      writer.uint32(18).string(message.toolCallId);
    }
    if (message.toolCallName !== "") {
      writer.uint32(26).string(message.toolCallName);
    }
    if (message.parentMessageId !== undefined) {
      writer.uint32(34).string(message.parentMessageId);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(42).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCallStartEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCallStartEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toolCallId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.toolCallName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parentMessageId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ToolCallStartEvent>, I>>(base?: I): ToolCallStartEvent {
    return ToolCallStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCallStartEvent>, I>>(object: I): ToolCallStartEvent {
    const message = createBaseToolCallStartEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.toolCallId = object.toolCallId ?? "";
    message.toolCallName = object.toolCallName ?? "";
    message.parentMessageId = object.parentMessageId ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseToolCallArgsEvent(): ToolCallArgsEvent {
  return { baseEvent: undefined, toolCallId: "", delta: "", subagentRunId: undefined };
}

export const ToolCallArgsEvent: MessageFns<ToolCallArgsEvent> = {
  encode(message: ToolCallArgsEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.toolCallId !== "") {
      writer.uint32(18).string(message.toolCallId);
    }
    if (message.delta !== "") {
      writer.uint32(26).string(message.delta);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(34).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCallArgsEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCallArgsEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toolCallId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.delta = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ToolCallArgsEvent>, I>>(base?: I): ToolCallArgsEvent {
    return ToolCallArgsEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCallArgsEvent>, I>>(object: I): ToolCallArgsEvent {
    const message = createBaseToolCallArgsEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.toolCallId = object.toolCallId ?? "";
    message.delta = object.delta ?? "";
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseToolCallEndEvent(): ToolCallEndEvent {
  return { baseEvent: undefined, toolCallId: "", subagentRunId: undefined };
}

export const ToolCallEndEvent: MessageFns<ToolCallEndEvent> = {
  encode(message: ToolCallEndEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.toolCallId !== "") {
      writer.uint32(18).string(message.toolCallId);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(26).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCallEndEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCallEndEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toolCallId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ToolCallEndEvent>, I>>(base?: I): ToolCallEndEvent {
    return ToolCallEndEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCallEndEvent>, I>>(object: I): ToolCallEndEvent {
    const message = createBaseToolCallEndEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.toolCallId = object.toolCallId ?? "";
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseStateSnapshotEvent(): StateSnapshotEvent {
  return { baseEvent: undefined, snapshot: undefined, subagentRunId: undefined };
}

export const StateSnapshotEvent: MessageFns<StateSnapshotEvent> = {
  encode(message: StateSnapshotEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.snapshot !== undefined) {
      Value.encode(Value.wrap(message.snapshot), writer.uint32(18).fork()).join();
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(26).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StateSnapshotEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStateSnapshotEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.snapshot = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<StateSnapshotEvent>, I>>(base?: I): StateSnapshotEvent {
    return StateSnapshotEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StateSnapshotEvent>, I>>(object: I): StateSnapshotEvent {
    const message = createBaseStateSnapshotEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.snapshot = object.snapshot ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseStateDeltaEvent(): StateDeltaEvent {
  return { baseEvent: undefined, delta: [], subagentRunId: undefined };
}

export const StateDeltaEvent: MessageFns<StateDeltaEvent> = {
  encode(message: StateDeltaEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    for (const v of message.delta) {
      JsonPatchOperation.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(26).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StateDeltaEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStateDeltaEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.delta.push(JsonPatchOperation.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<StateDeltaEvent>, I>>(base?: I): StateDeltaEvent {
    return StateDeltaEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StateDeltaEvent>, I>>(object: I): StateDeltaEvent {
    const message = createBaseStateDeltaEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.delta = object.delta?.map((e) => JsonPatchOperation.fromPartial(e)) || [];
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseMessagesSnapshotEvent(): MessagesSnapshotEvent {
  return { baseEvent: undefined, messages: [] };
}

export const MessagesSnapshotEvent: MessageFns<MessagesSnapshotEvent> = {
  encode(message: MessagesSnapshotEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    for (const v of message.messages) {
      Message.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessagesSnapshotEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessagesSnapshotEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messages.push(Message.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MessagesSnapshotEvent>, I>>(base?: I): MessagesSnapshotEvent {
    return MessagesSnapshotEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessagesSnapshotEvent>, I>>(object: I): MessagesSnapshotEvent {
    const message = createBaseMessagesSnapshotEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.messages = object.messages?.map((e) => Message.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRawEvent(): RawEvent {
  return { baseEvent: undefined, event: undefined, source: undefined, subagentRunId: undefined };
}

export const RawEvent: MessageFns<RawEvent> = {
  encode(message: RawEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.event !== undefined) {
      Value.encode(Value.wrap(message.event), writer.uint32(18).fork()).join();
    }
    if (message.source !== undefined) {
      writer.uint32(26).string(message.source);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(34).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RawEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRawEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.event = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.source = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RawEvent>, I>>(base?: I): RawEvent {
    return RawEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RawEvent>, I>>(object: I): RawEvent {
    const message = createBaseRawEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.event = object.event ?? undefined;
    message.source = object.source ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseCustomEvent(): CustomEvent {
  return { baseEvent: undefined, name: "", value: undefined, subagentRunId: undefined };
}

export const CustomEvent: MessageFns<CustomEvent> = {
  encode(message: CustomEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.value !== undefined) {
      Value.encode(Value.wrap(message.value), writer.uint32(26).fork()).join();
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(34).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CustomEvent>, I>>(base?: I): CustomEvent {
    return CustomEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomEvent>, I>>(object: I): CustomEvent {
    const message = createBaseCustomEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.name = object.name ?? "";
    message.value = object.value ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseRunStartedEvent(): RunStartedEvent {
  return { baseEvent: undefined, threadId: "", runId: "" };
}

export const RunStartedEvent: MessageFns<RunStartedEvent> = {
  encode(message: RunStartedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.threadId !== "") {
      writer.uint32(18).string(message.threadId);
    }
    if (message.runId !== "") {
      writer.uint32(26).string(message.runId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunStartedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunStartedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.runId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RunStartedEvent>, I>>(base?: I): RunStartedEvent {
    return RunStartedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunStartedEvent>, I>>(object: I): RunStartedEvent {
    const message = createBaseRunStartedEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.threadId = object.threadId ?? "";
    message.runId = object.runId ?? "";
    return message;
  },
};

function createBaseUsage(): Usage {
  return {
    provider: undefined,
    model: undefined,
    inputTokens: undefined,
    outputTokens: undefined,
    totalTokens: undefined,
    reasoningTokens: undefined,
    cachedInputTokens: undefined,
  };
}

export const Usage: MessageFns<Usage> = {
  encode(message: Usage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== undefined) {
      writer.uint32(10).string(message.provider);
    }
    if (message.model !== undefined) {
      writer.uint32(18).string(message.model);
    }
    if (message.inputTokens !== undefined) {
      writer.uint32(24).int64(message.inputTokens);
    }
    if (message.outputTokens !== undefined) {
      writer.uint32(32).int64(message.outputTokens);
    }
    if (message.totalTokens !== undefined) {
      writer.uint32(40).int64(message.totalTokens);
    }
    if (message.reasoningTokens !== undefined) {
      writer.uint32(48).int64(message.reasoningTokens);
    }
    if (message.cachedInputTokens !== undefined) {
      writer.uint32(56).int64(message.cachedInputTokens);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Usage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.inputTokens = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.outputTokens = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.totalTokens = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.reasoningTokens = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.cachedInputTokens = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Usage>, I>>(base?: I): Usage {
    return Usage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Usage>, I>>(object: I): Usage {
    const message = createBaseUsage();
    message.provider = object.provider ?? undefined;
    message.model = object.model ?? undefined;
    message.inputTokens = object.inputTokens ?? undefined;
    message.outputTokens = object.outputTokens ?? undefined;
    message.totalTokens = object.totalTokens ?? undefined;
    message.reasoningTokens = object.reasoningTokens ?? undefined;
    message.cachedInputTokens = object.cachedInputTokens ?? undefined;
    return message;
  },
};

function createBaseRunFinishedEvent(): RunFinishedEvent {
  return { baseEvent: undefined, threadId: "", runId: "", result: undefined, outcome: "", interrupts: [], usage: [] };
}

export const RunFinishedEvent: MessageFns<RunFinishedEvent> = {
  encode(message: RunFinishedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.threadId !== "") {
      writer.uint32(18).string(message.threadId);
    }
    if (message.runId !== "") {
      writer.uint32(26).string(message.runId);
    }
    if (message.result !== undefined) {
      Value.encode(Value.wrap(message.result), writer.uint32(34).fork()).join();
    }
    if (message.outcome !== "") {
      writer.uint32(42).string(message.outcome);
    }
    for (const v of message.interrupts) {
      Interrupt.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.usage) {
      Usage.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunFinishedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunFinishedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.runId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.result = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.outcome = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.interrupts.push(Interrupt.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.usage.push(Usage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RunFinishedEvent>, I>>(base?: I): RunFinishedEvent {
    return RunFinishedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunFinishedEvent>, I>>(object: I): RunFinishedEvent {
    const message = createBaseRunFinishedEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.threadId = object.threadId ?? "";
    message.runId = object.runId ?? "";
    message.result = object.result ?? undefined;
    message.outcome = object.outcome ?? "";
    message.interrupts = object.interrupts?.map((e) => Interrupt.fromPartial(e)) || [];
    message.usage = object.usage?.map((e) => Usage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRunErrorEvent(): RunErrorEvent {
  return { baseEvent: undefined, code: undefined, message: "", usage: [] };
}

export const RunErrorEvent: MessageFns<RunErrorEvent> = {
  encode(message: RunErrorEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.code !== undefined) {
      writer.uint32(18).string(message.code);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    for (const v of message.usage) {
      Usage.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunErrorEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunErrorEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.usage.push(Usage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RunErrorEvent>, I>>(base?: I): RunErrorEvent {
    return RunErrorEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunErrorEvent>, I>>(object: I): RunErrorEvent {
    const message = createBaseRunErrorEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.code = object.code ?? undefined;
    message.message = object.message ?? "";
    message.usage = object.usage?.map((e) => Usage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStepStartedEvent(): StepStartedEvent {
  return { baseEvent: undefined, stepName: "", subagentRunId: undefined };
}

export const StepStartedEvent: MessageFns<StepStartedEvent> = {
  encode(message: StepStartedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.stepName !== "") {
      writer.uint32(18).string(message.stepName);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(26).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepStartedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepStartedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<StepStartedEvent>, I>>(base?: I): StepStartedEvent {
    return StepStartedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepStartedEvent>, I>>(object: I): StepStartedEvent {
    const message = createBaseStepStartedEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.stepName = object.stepName ?? "";
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseStepFinishedEvent(): StepFinishedEvent {
  return { baseEvent: undefined, stepName: "", subagentRunId: undefined };
}

export const StepFinishedEvent: MessageFns<StepFinishedEvent> = {
  encode(message: StepFinishedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.stepName !== "") {
      writer.uint32(18).string(message.stepName);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(26).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepFinishedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepFinishedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<StepFinishedEvent>, I>>(base?: I): StepFinishedEvent {
    return StepFinishedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepFinishedEvent>, I>>(object: I): StepFinishedEvent {
    const message = createBaseStepFinishedEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.stepName = object.stepName ?? "";
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseTextMessageChunkEvent(): TextMessageChunkEvent {
  return {
    baseEvent: undefined,
    messageId: undefined,
    role: undefined,
    delta: undefined,
    name: undefined,
    subagentRunId: undefined,
  };
}

export const TextMessageChunkEvent: MessageFns<TextMessageChunkEvent> = {
  encode(message: TextMessageChunkEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.messageId !== undefined) {
      writer.uint32(18).string(message.messageId);
    }
    if (message.role !== undefined) {
      writer.uint32(26).string(message.role);
    }
    if (message.delta !== undefined) {
      writer.uint32(34).string(message.delta);
    }
    if (message.name !== undefined) {
      writer.uint32(42).string(message.name);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(50).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextMessageChunkEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextMessageChunkEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.delta = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TextMessageChunkEvent>, I>>(base?: I): TextMessageChunkEvent {
    return TextMessageChunkEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextMessageChunkEvent>, I>>(object: I): TextMessageChunkEvent {
    const message = createBaseTextMessageChunkEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.messageId = object.messageId ?? undefined;
    message.role = object.role ?? undefined;
    message.delta = object.delta ?? undefined;
    message.name = object.name ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseToolCallChunkEvent(): ToolCallChunkEvent {
  return {
    baseEvent: undefined,
    toolCallId: undefined,
    toolCallName: undefined,
    parentMessageId: undefined,
    delta: undefined,
    subagentRunId: undefined,
  };
}

export const ToolCallChunkEvent: MessageFns<ToolCallChunkEvent> = {
  encode(message: ToolCallChunkEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.toolCallId !== undefined) {
      writer.uint32(18).string(message.toolCallId);
    }
    if (message.toolCallName !== undefined) {
      writer.uint32(26).string(message.toolCallName);
    }
    if (message.parentMessageId !== undefined) {
      writer.uint32(34).string(message.parentMessageId);
    }
    if (message.delta !== undefined) {
      writer.uint32(42).string(message.delta);
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(50).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCallChunkEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCallChunkEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toolCallId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.toolCallName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parentMessageId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.delta = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ToolCallChunkEvent>, I>>(base?: I): ToolCallChunkEvent {
    return ToolCallChunkEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCallChunkEvent>, I>>(object: I): ToolCallChunkEvent {
    const message = createBaseToolCallChunkEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.toolCallId = object.toolCallId ?? undefined;
    message.toolCallName = object.toolCallName ?? undefined;
    message.parentMessageId = object.parentMessageId ?? undefined;
    message.delta = object.delta ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseSubagentStartedEvent(): SubagentStartedEvent {
  return {
    baseEvent: undefined,
    subagentRunId: "",
    name: "",
    description: undefined,
    parentSubagentRunId: undefined,
    parentToolCallId: undefined,
    parentMessageId: undefined,
  };
}

export const SubagentStartedEvent: MessageFns<SubagentStartedEvent> = {
  encode(message: SubagentStartedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.subagentRunId !== "") {
      writer.uint32(18).string(message.subagentRunId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.parentSubagentRunId !== undefined) {
      writer.uint32(42).string(message.parentSubagentRunId);
    }
    if (message.parentToolCallId !== undefined) {
      writer.uint32(50).string(message.parentToolCallId);
    }
    if (message.parentMessageId !== undefined) {
      writer.uint32(58).string(message.parentMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubagentStartedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubagentStartedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parentSubagentRunId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentToolCallId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.parentMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SubagentStartedEvent>, I>>(base?: I): SubagentStartedEvent {
    return SubagentStartedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubagentStartedEvent>, I>>(object: I): SubagentStartedEvent {
    const message = createBaseSubagentStartedEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.subagentRunId = object.subagentRunId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? undefined;
    message.parentSubagentRunId = object.parentSubagentRunId ?? undefined;
    message.parentToolCallId = object.parentToolCallId ?? undefined;
    message.parentMessageId = object.parentMessageId ?? undefined;
    return message;
  },
};

function createBaseSubagentFinishedEvent(): SubagentFinishedEvent {
  return { baseEvent: undefined, subagentRunId: "", result: undefined, outcome: "", interruptIds: [] };
}

export const SubagentFinishedEvent: MessageFns<SubagentFinishedEvent> = {
  encode(message: SubagentFinishedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.subagentRunId !== "") {
      writer.uint32(18).string(message.subagentRunId);
    }
    if (message.result !== undefined) {
      Value.encode(Value.wrap(message.result), writer.uint32(26).fork()).join();
    }
    if (message.outcome !== "") {
      writer.uint32(34).string(message.outcome);
    }
    for (const v of message.interruptIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubagentFinishedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubagentFinishedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.result = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.outcome = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.interruptIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SubagentFinishedEvent>, I>>(base?: I): SubagentFinishedEvent {
    return SubagentFinishedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubagentFinishedEvent>, I>>(object: I): SubagentFinishedEvent {
    const message = createBaseSubagentFinishedEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.subagentRunId = object.subagentRunId ?? "";
    message.result = object.result ?? undefined;
    message.outcome = object.outcome ?? "";
    message.interruptIds = object.interruptIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseSubagentErrorEvent(): SubagentErrorEvent {
  return { baseEvent: undefined, subagentRunId: "", message: "", code: undefined };
}

export const SubagentErrorEvent: MessageFns<SubagentErrorEvent> = {
  encode(message: SubagentErrorEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseEvent !== undefined) {
      BaseEvent.encode(message.baseEvent, writer.uint32(10).fork()).join();
    }
    if (message.subagentRunId !== "") {
      writer.uint32(18).string(message.subagentRunId);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    if (message.code !== undefined) {
      writer.uint32(34).string(message.code);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubagentErrorEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubagentErrorEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseEvent = BaseEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.code = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SubagentErrorEvent>, I>>(base?: I): SubagentErrorEvent {
    return SubagentErrorEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubagentErrorEvent>, I>>(object: I): SubagentErrorEvent {
    const message = createBaseSubagentErrorEvent();
    message.baseEvent = (object.baseEvent !== undefined && object.baseEvent !== null)
      ? BaseEvent.fromPartial(object.baseEvent)
      : undefined;
    message.subagentRunId = object.subagentRunId ?? "";
    message.message = object.message ?? "";
    message.code = object.code ?? undefined;
    return message;
  },
};

function createBaseEvent(): Event {
  return {
    textMessageStart: undefined,
    textMessageContent: undefined,
    textMessageEnd: undefined,
    toolCallStart: undefined,
    toolCallArgs: undefined,
    toolCallEnd: undefined,
    stateSnapshot: undefined,
    stateDelta: undefined,
    messagesSnapshot: undefined,
    raw: undefined,
    custom: undefined,
    runStarted: undefined,
    runFinished: undefined,
    runError: undefined,
    stepStarted: undefined,
    stepFinished: undefined,
    textMessageChunk: undefined,
    toolCallChunk: undefined,
    subagentStarted: undefined,
    subagentFinished: undefined,
    subagentError: undefined,
  };
}

export const Event: MessageFns<Event> = {
  encode(message: Event, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.textMessageStart !== undefined) {
      TextMessageStartEvent.encode(message.textMessageStart, writer.uint32(10).fork()).join();
    }
    if (message.textMessageContent !== undefined) {
      TextMessageContentEvent.encode(message.textMessageContent, writer.uint32(18).fork()).join();
    }
    if (message.textMessageEnd !== undefined) {
      TextMessageEndEvent.encode(message.textMessageEnd, writer.uint32(26).fork()).join();
    }
    if (message.toolCallStart !== undefined) {
      ToolCallStartEvent.encode(message.toolCallStart, writer.uint32(34).fork()).join();
    }
    if (message.toolCallArgs !== undefined) {
      ToolCallArgsEvent.encode(message.toolCallArgs, writer.uint32(42).fork()).join();
    }
    if (message.toolCallEnd !== undefined) {
      ToolCallEndEvent.encode(message.toolCallEnd, writer.uint32(50).fork()).join();
    }
    if (message.stateSnapshot !== undefined) {
      StateSnapshotEvent.encode(message.stateSnapshot, writer.uint32(58).fork()).join();
    }
    if (message.stateDelta !== undefined) {
      StateDeltaEvent.encode(message.stateDelta, writer.uint32(66).fork()).join();
    }
    if (message.messagesSnapshot !== undefined) {
      MessagesSnapshotEvent.encode(message.messagesSnapshot, writer.uint32(74).fork()).join();
    }
    if (message.raw !== undefined) {
      RawEvent.encode(message.raw, writer.uint32(82).fork()).join();
    }
    if (message.custom !== undefined) {
      CustomEvent.encode(message.custom, writer.uint32(90).fork()).join();
    }
    if (message.runStarted !== undefined) {
      RunStartedEvent.encode(message.runStarted, writer.uint32(98).fork()).join();
    }
    if (message.runFinished !== undefined) {
      RunFinishedEvent.encode(message.runFinished, writer.uint32(106).fork()).join();
    }
    if (message.runError !== undefined) {
      RunErrorEvent.encode(message.runError, writer.uint32(114).fork()).join();
    }
    if (message.stepStarted !== undefined) {
      StepStartedEvent.encode(message.stepStarted, writer.uint32(122).fork()).join();
    }
    if (message.stepFinished !== undefined) {
      StepFinishedEvent.encode(message.stepFinished, writer.uint32(130).fork()).join();
    }
    if (message.textMessageChunk !== undefined) {
      TextMessageChunkEvent.encode(message.textMessageChunk, writer.uint32(138).fork()).join();
    }
    if (message.toolCallChunk !== undefined) {
      ToolCallChunkEvent.encode(message.toolCallChunk, writer.uint32(146).fork()).join();
    }
    if (message.subagentStarted !== undefined) {
      SubagentStartedEvent.encode(message.subagentStarted, writer.uint32(154).fork()).join();
    }
    if (message.subagentFinished !== undefined) {
      SubagentFinishedEvent.encode(message.subagentFinished, writer.uint32(162).fork()).join();
    }
    if (message.subagentError !== undefined) {
      SubagentErrorEvent.encode(message.subagentError, writer.uint32(170).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Event {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.textMessageStart = TextMessageStartEvent.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.textMessageContent = TextMessageContentEvent.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.textMessageEnd = TextMessageEndEvent.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.toolCallStart = ToolCallStartEvent.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.toolCallArgs = ToolCallArgsEvent.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.toolCallEnd = ToolCallEndEvent.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.stateSnapshot = StateSnapshotEvent.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stateDelta = StateDeltaEvent.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.messagesSnapshot = MessagesSnapshotEvent.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.raw = RawEvent.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.custom = CustomEvent.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.runStarted = RunStartedEvent.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.runFinished = RunFinishedEvent.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.runError = RunErrorEvent.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.stepStarted = StepStartedEvent.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.stepFinished = StepFinishedEvent.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.textMessageChunk = TextMessageChunkEvent.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.toolCallChunk = ToolCallChunkEvent.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.subagentStarted = SubagentStartedEvent.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.subagentFinished = SubagentFinishedEvent.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.subagentError = SubagentErrorEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Event>, I>>(base?: I): Event {
    return Event.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Event>, I>>(object: I): Event {
    const message = createBaseEvent();
    message.textMessageStart = (object.textMessageStart !== undefined && object.textMessageStart !== null)
      ? TextMessageStartEvent.fromPartial(object.textMessageStart)
      : undefined;
    message.textMessageContent = (object.textMessageContent !== undefined && object.textMessageContent !== null)
      ? TextMessageContentEvent.fromPartial(object.textMessageContent)
      : undefined;
    message.textMessageEnd = (object.textMessageEnd !== undefined && object.textMessageEnd !== null)
      ? TextMessageEndEvent.fromPartial(object.textMessageEnd)
      : undefined;
    message.toolCallStart = (object.toolCallStart !== undefined && object.toolCallStart !== null)
      ? ToolCallStartEvent.fromPartial(object.toolCallStart)
      : undefined;
    message.toolCallArgs = (object.toolCallArgs !== undefined && object.toolCallArgs !== null)
      ? ToolCallArgsEvent.fromPartial(object.toolCallArgs)
      : undefined;
    message.toolCallEnd = (object.toolCallEnd !== undefined && object.toolCallEnd !== null)
      ? ToolCallEndEvent.fromPartial(object.toolCallEnd)
      : undefined;
    message.stateSnapshot = (object.stateSnapshot !== undefined && object.stateSnapshot !== null)
      ? StateSnapshotEvent.fromPartial(object.stateSnapshot)
      : undefined;
    message.stateDelta = (object.stateDelta !== undefined && object.stateDelta !== null)
      ? StateDeltaEvent.fromPartial(object.stateDelta)
      : undefined;
    message.messagesSnapshot = (object.messagesSnapshot !== undefined && object.messagesSnapshot !== null)
      ? MessagesSnapshotEvent.fromPartial(object.messagesSnapshot)
      : undefined;
    message.raw = (object.raw !== undefined && object.raw !== null) ? RawEvent.fromPartial(object.raw) : undefined;
    message.custom = (object.custom !== undefined && object.custom !== null)
      ? CustomEvent.fromPartial(object.custom)
      : undefined;
    message.runStarted = (object.runStarted !== undefined && object.runStarted !== null)
      ? RunStartedEvent.fromPartial(object.runStarted)
      : undefined;
    message.runFinished = (object.runFinished !== undefined && object.runFinished !== null)
      ? RunFinishedEvent.fromPartial(object.runFinished)
      : undefined;
    message.runError = (object.runError !== undefined && object.runError !== null)
      ? RunErrorEvent.fromPartial(object.runError)
      : undefined;
    message.stepStarted = (object.stepStarted !== undefined && object.stepStarted !== null)
      ? StepStartedEvent.fromPartial(object.stepStarted)
      : undefined;
    message.stepFinished = (object.stepFinished !== undefined && object.stepFinished !== null)
      ? StepFinishedEvent.fromPartial(object.stepFinished)
      : undefined;
    message.textMessageChunk = (object.textMessageChunk !== undefined && object.textMessageChunk !== null)
      ? TextMessageChunkEvent.fromPartial(object.textMessageChunk)
      : undefined;
    message.toolCallChunk = (object.toolCallChunk !== undefined && object.toolCallChunk !== null)
      ? ToolCallChunkEvent.fromPartial(object.toolCallChunk)
      : undefined;
    message.subagentStarted = (object.subagentStarted !== undefined && object.subagentStarted !== null)
      ? SubagentStartedEvent.fromPartial(object.subagentStarted)
      : undefined;
    message.subagentFinished = (object.subagentFinished !== undefined && object.subagentFinished !== null)
      ? SubagentFinishedEvent.fromPartial(object.subagentFinished)
      : undefined;
    message.subagentError = (object.subagentError !== undefined && object.subagentError !== null)
      ? SubagentErrorEvent.fromPartial(object.subagentError)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
